import type { ProtocolId } from '../../shared/types';

export interface StoryLine {
  kicker: string;
  text: string;
}

export function archiveNarrative(docsRecovered: number): StoryLine {
  if (docsRecovered >= 35) {
    return {
      kicker: 'DIRECTORATE / FINAL INTERCEPT',
      text: '没有出口。只有下一组受试者。',
    };
  }
  if (docsRecovered >= 25) {
    return {
      kicker: 'DIRECTORATE / STANDARD',
      text: '委员会保留了房间，也保留了方法。校准不再属于 Site 06。',
    };
  }
  if (docsRecovered >= 15) {
    return {
      kicker: 'INTAKE / ANOMALY',
      text: '配对记录里反复出现一个不存在的样本。系统坚持认为配对成功。',
    };
  }
  if (docsRecovered >= 6) {
    return {
      kicker: 'CIVILIAN / LEAKAGE',
      text: 'CHROMA 已经离开设施：学校、工厂、广播系统都在使用同一套颜色纪律。',
    };
  }
  if (docsRecovered >= 1) {
    return {
      kicker: 'ARCHIVE / FIRST LINE',
      text: '你已经拼出第一句话：这不是一场游戏。',
    };
  }
  return {
    kicker: 'ARCHIVE / EMPTY',
    text: '归档为空。系统尚未判断你是否值得知道更多。',
  };
}

export function endStory(
  protocol: ProtocolId,
  survived: boolean,
  docsRecovered: number,
): StoryLine {
  if (docsRecovered >= 35) {
    return {
      kicker: 'ARCHIVE INTERCEPT / SESSION CONTINUES',
      text: '你已经读到委员会的最后一句：下一组受试者已经在登记处等待。',
    };
  }
  if (protocol >= 6) {
    return {
      kicker: 'ARCHIVE INTERCEPT / PROTOCOL VI',
      text: '房间记录到了协议 VI。设施没有停止，只是把门留给了下一组配对。',
    };
  }
  if (protocol >= 4) {
    return {
      kicker: 'ARCHIVE INTERCEPT / CONTAMINATION',
      text: '污染读数超过了房间的设计阈值。值班室没有提交关闭申请。',
    };
  }
  return {
    kicker: 'ARCHIVE INTERCEPT / OBSERVATION',
    text: survived
      ? '样本仍在观察名单上。委员会不区分一次校准与一次服从。'
      : '系统不区分失败与退出；它只记录你是否回答了问题。',
  };
}
